// extracted by mini-css-extract-plugin
export default {"errors":"fouK8LYtEq6","shiftErrorBox":"fouO468HD9e","errorItem":"foueNI_dC2a","skip":"foutrMbjodV","close":"fouACHSaU9O"};